import { currencyFormatter } from "../../../../../utils/currency";

export const getSelectedVariantSku = (result) => {
    if (result?.remainingOptions) {
        for (const remainingOption of result.remainingOptions) {
            if (remainingOption.attributeKey.toLowerCase() === 'mcpsku' && remainingOption.attributeValues.length > 0) {
                return remainingOption.attributeValues[0].value;
            }
        }
    }
    return '';
};

export const getCartItemUserSelections = (cartItem) => {
    let userSelections = {};
    for (const userSelection of cartItem.productAttributes.userSelectionInfo) {
        if (userSelection.originalAttributeKey && userSelection.originalAttributeValue) {
            userSelections[userSelection.originalAttributeKey] = userSelection.originalAttributeValue;
        }
    }
    return userSelections;
};




export const getLatestPricingInfo = (priceInfo, type , fractionDigits) => {
    if (Object.keys(priceInfo).length > 0) {
        if (priceInfo?.tier) {
            let priceAndQtyInfo = priceInfo.discountedTier ? priceInfo.discountedTier : priceInfo.tier;

            const unitPrice = (priceAndQtyInfo.unitPrice ? priceAndQtyInfo.unitPrice : 0);
            let excTaxValue = (priceAndQtyInfo.totalExclTax ? priceAndQtyInfo.totalExclTax : 0);
            let incTaxValue = (priceAndQtyInfo.totalInclTax ? priceAndQtyInfo.totalInclTax : 0);
            let setupCharge = (priceAndQtyInfo.setupCharge ? priceAndQtyInfo.setupCharge : 0);

            if (setupCharge > 0) {
                excTaxValue = ((priceAndQtyInfo.withoutTax && priceAndQtyInfo.withoutTax.charges && priceAndQtyInfo.withoutTax.charges.totalWithSetup) ? priceAndQtyInfo.withoutTax.charges.totalWithSetup : 0);
                incTaxValue = ((priceAndQtyInfo.withTax && priceAndQtyInfo.withTax.charges && priceAndQtyInfo.withTax.charges.totalWithSetup) ? priceAndQtyInfo.withTax.charges.totalWithSetup : 0);
            }

            const priceValue = type === 'unit-price' ? (unitPrice) : (type === 'price-excl-vat' ? excTaxValue : incTaxValue);
            return currencyFormatter(priceValue, fractionDigits);
        }
    } else {
      return '';
    }
  }